import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API, LOGO_URL } from "@/lib/api";
import { sessionId } from "@/lib/partners";

export default function TrackRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/public/track/${code}`, { params: { sid: sessionId() } })
      .then((r) => navigate(`/revival/${r.data.slug}`, { replace: true }))
      .catch(() => setError(true));
  }, [code, navigate]);

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 text-center" data-testid="track-redirect">
      <img src={LOGO_URL} alt="ARK Furniture" className="h-12 mb-8" />
      {error ? (
        <>
          <h1 className="font-display text-2xl mb-3">This link is no longer active</h1>
          <p className="text-gray-500 text-sm">Please contact ARK Furniture or your realtor for an updated link.</p>
        </>
      ) : (
        <div className="w-8 h-8 border-2 border-black border-t-[#c19a6b] rounded-full animate-spin" />
      )}
    </div>
  );
}
